import { render } from "./input-element.vue?vue&type=template&id=0015e158"
import script from "./input-element.vue?vue&type=script&lang=ts"
export * from "./input-element.vue?vue&type=script&lang=ts"
script.render = render

export default script